import { useContext } from 'react';

import { TYPE_LABELS } from '@atom/components/common/requests/assetRequestConstants';
import { getDisplayDateTime } from '@atom/utilities/timeUtilities';

import ViewRequestContext from '../ViewRequestContext';

import classes from './sddotView.module.css';

const SDDOTAdjustmentView = () => {
  const { activeRequest } = useContext(ViewRequestContext);

  const createdByText = `Created by ${activeRequest?.createdBy?.firstName} ${
    activeRequest?.createdBy?.lastName
  } on ${getDisplayDateTime(activeRequest?.createdDate)}`;

  return (
    <div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Request Type</div>
        <div>{TYPE_LABELS[activeRequest?.type]}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Inventory Name</div>
        <div>{activeRequest?.assetName}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>{`Quantity Adjusted (${
          activeRequest?.assetUnit || ''
        })`}</div>
        <div>{activeRequest?.quantity}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Adjustment Reason</div>
        <div>{activeRequest?.reason}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Comments</div>
        <div>{activeRequest?.comments}</div>
      </div>
      <div className={classes.createdSubtext}>{createdByText}</div>
    </div>
  );
};

export default SDDOTAdjustmentView;
